import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { backfillAggregations, recalculateMonthAggregation } from './utils/backfillAggregations';
import { checkMonthlyPlanEnding } from './utils/notificationService';

// APIs no console (dev/ops): recalcular agregações e testar avisos de plano
window.recalcularAgregacoes = (startYear = 2020, endYear = new Date().getFullYear()) =>
  backfillAggregations(startYear, endYear);

window.recalcularMes = (year, month) => recalculateMonthAggregation(year, month);

window.verificarPlanos = () => checkMonthlyPlanEnding();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

